import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=f3028650&scoped=true&"
var script = {}
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=f3028650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3028650",
  null
  
)

export default component.exports